import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'

export default ({ value, facet }) => {
    const { toggleProductFilter } = useActions()

    return (
        <>
            <li
                class="ns-mobile-facet-filter ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                data-nosto-element="facet-setting">
                <label class="ns-checkbox ns-d-block ns-color-grey-dark">
                    {value.value}
                    <input
                        type="checkbox"
                        checked={value.selected}
                        onChange={(e) => {
                            e.preventDefault()
                            toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                    <span class="ns-checkmark-mobile"></span>
                </label>
            </li>
        </>
    )
}
